/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import loadable from '@loadable/component';

import { preloadComponent } from '../shared/utils';
import Loader from './partials/loader';

const LazyForm = loadable(() => import('./form/components/form'), {
  fallback: <Loader />,
});

const FormBase = () => {
  useEffect(() => preloadComponent(LazyForm), []);

  return (
    <Router basename="/form">
      <Route path="/:id" render={(props) => <LazyForm {...props} />} />
    </Router>
  );
};

export default FormBase;
